import { render } from "./ToolsView.vue?vue&type=template&id=447d459c&scoped=true&ts=true"
import script from "./ToolsView.vue?vue&type=script&lang=ts"
export * from "./ToolsView.vue?vue&type=script&lang=ts"

import "./ToolsView.vue?vue&type=style&index=0&id=447d459c&scoped=true&lang=css"

import exportComponent from "/frontside/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447d459c"]])

export default __exports__